import React from "react";

const AnalyticsCards = ({ stats, agent, selectedRangeLabel, totalLeads }) => {
  if (!stats) return null;

  const cardClass = "incomingleads-card";

  const getCards = () => {
    const totalCallsCard = {
      id: "totalLeads",
      label: "Total Calls",
      value: stats.totalCall,
      bgColor: "#EFEBFC",
      iconColor: "#6f42c1",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      ),
    };

    const callInitiated = {
      id: "callInitiated",
      label: "Calls Initiated",
      value: stats.callInitiate,
      bgColor: "#E0F2FE",
      iconColor: "#0ea5e9",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          <path d="M14.05 2a9 9 0 0 1 8 7.94"></path>
          <path d="M14.05 6A5 5 0 0 1 18 10"></path>
        </svg>
      ),
    };

    const concludeCalls = {
      id: "concludeCalls",
      label: "Concluded Calls",
      value: stats.callConcluded,
      bgColor: "#EAF9F0",
      iconColor: "#10B981",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      ),
    };

    // const interestedInFuture = {
    //   id: "interestedInFuture",
    //   label: "Interested in Future",
    //   value: stats.interestedInFuture,
    //   bgColor: "#FEF6E7",
    //   iconColor: "#F59E0B",
    //   icon: (
    //     <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    //       <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
    //     </svg>
    //   ),
    // };

    const notInterested = {
      id: "notInterested",
      label: "Not Interested",
      value: stats.notInterested,
      bgColor: "#F5EFFE",
      iconColor: "#a855f7",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 14V2"></path>
          <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z"></path>
        </svg>
      ),
    };

    const notConcluded = {
      id: "notConcluded",
      label: "Not Concluded",
      value: stats.notConcluded,
      bgColor: "#EBF3FE",
      iconColor: "#3b82f6",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
          <line x1="18" y1="4" x2="22" y2="8"></line>
          <line x1="22" y1="4" x2="18" y2="8"></line>
        </svg>
      ),
    };

    const failedCalls = {
      id: "failedCalls",
      label: "Failed Calls",
      value: stats.callFail,
      bgColor: "#FDF0F0",
      iconColor: "#EF4444",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      ),
    };

    const totalLeadsCard = totalLeads !== null && totalLeads !== undefined ? {
      id: "totalLeadsAll",
      label: "Total Leads",
      value: totalLeads,
      bgColor: "#E6FAF5",
      iconColor: "#059669",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <ellipse cx="12" cy="5" rx="9" ry="3"></ellipse>
          <path d="M3 5v14c0 1.66 4.03 3 9 3s9-1.34 9-3V5"></path>
          <path d="M3 12c0 1.66 4.03 3 9 3s9-1.34 9-3"></path>
        </svg>
      ),
    } : null;

    const cards = [totalCallsCard, callInitiated, concludeCalls, notInterested, notConcluded, failedCalls];
    if (totalLeadsCard) cards.unshift(totalLeadsCard);
    return cards;
  };

  const cardsToShow = getCards();

  return (
    <div className="py-1">
      <div className="row">
        {cardsToShow.map((card) => {
          const isZero = !card.value || card.value === 0;
          const finalBgColor = isZero ? "#F3F6F9" : card.bgColor;
          const finalIconColor = isZero ? "#A1A5B7" : card.iconColor;
          const finalValueColor = isZero ? "#B5B5C3" : "#181C32";

          return (
            <div key={card.id} className={`analytics-card-col ${cardClass}`}>
              <div
                className="card card-custom h-100 shadow-sm border-0 bg-white w-100"
                style={{
                  padding: "20px 22px",
                  borderRadius: "12px",
                  boxShadow: "0 10px 30px rgba(82, 63, 105, 0.03)",
                  border: "1px solid #F3F4F6",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  opacity: isZero ? 0.85 : 1,
                  transition: "all 0.3s ease"
                }}
              >
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="kpi-icon-container rounded-circle"
                    style={{
                      backgroundColor: finalBgColor,
                      color: finalIconColor
                    }}
                  >
                    {card.icon}
                  </div>
                  <div className="ml-2 ml-sm-3 ml-lg-4">
                    <div
                      className="kpi-card-label"
                      style={{
                        color: isZero ? "#8A8A9A" : "#2F3349",
                        fontWeight: 600,
                        letterSpacing: "0.2px"
                      }}
                    >
                      {card.label}
                    </div>
                    <div
                      className="kpi-card-value font-weight-bolder mt-1"
                      style={{
                        fontWeight: "800",
                        color: finalValueColor,
                        lineHeight: 1.1,
                        transition: "all 0.3s ease"
                      }}
                    >
                      {card.value?.toLocaleString() || 0}
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center" style={{ marginTop: "auto" }}>
                  <span style={{ fontSize: "0.75rem", color: "#5E6278", fontWeight: 600 }}>{selectedRangeLabel}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(AnalyticsCards);
